import { render, staticRenderFns } from "./Allcom.vue?vue&type=template&id=37edb3fa&scoped=true&"
import script from "./Allcom.vue?vue&type=script&lang=js&"
export * from "./Allcom.vue?vue&type=script&lang=js&"
import style0 from "./Allcom.vue?vue&type=style&index=0&id=37edb3fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37edb3fa",
  null
  
)

export default component.exports